<m-modal
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ width: '450px' }"
  appendTo="body"
  (onHide)="close()"
  (onShow)="onModalShow()">
  <ng-container modalHeader>
    <span class="h4 mb-0">Report Issue</span>
  </ng-container>

  <div class="feedback-modal-content">
    <!-- Request Category dropdown - always visible -->
    <div class="form-field">
      <label class="b2 text-gray-800">Request Category (required)</label>
      <m-dropdown
        panelStyleClass="feedback-dropdown-panel"
        [options]="categories"
        optionLabel="label"
        placeholder="Select a category"
        [ngModel]="selectedCategory"
        (formControlChange)="selectedCategory = $event?.value">
      </m-dropdown>
    </div>

    <!-- Description textarea - always visible -->
    <div class="form-field">
      <label class="b2 text-gray-800">Description (required)</label>
      <textarea
        pTextarea
        [(ngModel)]="message"
        placeholder="Please describe the issue..."
        rows="5"
        class="w-full">
      </textarea>
    </div>

    <!-- Screenshot section -->
    <div class="form-field">
      @if (isCapturingScreenshot) {
        <div class="flex flex-col gap-2">
          <m-skeleton height="236px"></m-skeleton>
          <span class="b2 text-gray-600"
            >Taking a screenshot of the dashboard...</span
          >
        </div>
      } @else if (!screenshotData) {
        <m-button
          type="secondary"
          icon="pi pi-image"
          label="Take a screenshot"
          (click)="captureScreenshot()">
        </m-button>
      } @else {
        <div class="screenshot-preview">
          <img [src]="screenshotData" alt="Screenshot preview" />
          <div class="screenshot-actions">
            <m-button
              type="tertiary"
              icon="pi pi-refresh"
              (click)="captureScreenshot()"
              label="Retake screenshot">
            </m-button>
            <m-button
              type="tertiary"
              icon="pi pi-trash"
              (click)="removeScreenshot()"
              label="Remove screenshot">
            </m-button>
          </div>
        </div>
      }
    </div>

    <!-- Submission result -->
    @if (submitResult === "success") {
      <m-messages
        [closable]="false"
        [messages]="[
          {
            severity: 'success',
            detail:
              'Your issue has been reported. A Jira ticket link will be sent to you via Slack. Thank you!',
          },
        ]">
      </m-messages>
    }
    @if (submitResult === "error") {
      <m-messages
        [closable]="false"
        [messages]="[
          {
            severity: 'error',
            detail: 'Failed to submit your issue. Please try again.',
          },
        ]">
      </m-messages>
    }
  </div>

  <ng-container modalFooter>
    <div class="feedback-modal-footer">
      <m-button type="tertiary" (click)="close()">Cancel</m-button>
      <m-button
        type="primary"
        label="Submit Issue"
        [loading]="isSubmitting"
        [disabled]="
          !message.trim() ||
          !selectedCategory ||
          isSubmitting ||
          submitResult === 'success'
        "
        (click)="onSubmit()">
      </m-button>
    </div>
  </ng-container>
</m-modal>
